

















































import Vue from 'vue';

import AppBar from '@/components/AppBar.vue';
import NoteThumbnail from '@/components/NoteThumbnail.vue';
import Footer from '@/components/Footer.vue';

export default Vue.extend({
  components: {
    AppBar,
    NoteThumbnail,
    Footer,
  },
  computed: {
    spaceId() {
      return this.$route.params.spaceid;
    },
    notes() {
      const notes = this.$store.state.notes.filter((note: any) => {
        if (this.$store.state.loggedIn) {
          return ![this.$store.state.user.draft.id].includes(note.id);
        } else {
          return true;
        }
      });
      const sorted = Array.from(notes).sort((a: any, b: any) => {
        return b.lastUpdated.seconds - a.lastUpdated.seconds;
      });
      return sorted;
    },
  },
  methods: {
    isOwner() {
      return this.$store.state.user
        ? this.spaceId === this.$store.state.user.space.id
        : false;
    },
  },
  created() {
    this.$store.dispatch('bindNotes', { spaceId: this.spaceId });
  },
});
